import React from 'react';
import AudiotrackIcon from '@mui/icons-material/Audiotrack';

const AudioMessageAttachment = () => (<AudiotrackIcon />);

export default AudioMessageAttachment;
